import { Spinner, Table } from 'react-bootstrap'
import WorkroomFolderTableRow from './WorkroomFolderTableRow'
import { FunctionComponent } from 'react'
import { useWorkroom } from './WorkroomContext'
import { useTranslation } from 'react-i18next'

const WorkroomTable: FunctionComponent = () => {
  const { t } = useTranslation()
  const { foldersAndDocuments, isLoading } = useWorkroom()

  return (
    <>
      {isLoading ? (
        <div className="d-flex p-4 justify-content-center">
          <Spinner variant="secondary" animation="border" />
        </div>
      ) : (
        <Table responsive className="w-100 d-table mt-2">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col">{t('workrooms.documents.table-name')}</th>
              <th scope="col">{t('workrooms.documents.table-created-by')}</th>
              <th scope="col" className="text-end">
                {t('workrooms.documents.table-created-edited-date')}
              </th>
            </tr>
          </thead>
          <tbody>
            {foldersAndDocuments.map((item) => (
              <WorkroomFolderTableRow {...item} key={`item-${item.name}-${item.id}`} />
            ))}
          </tbody>
        </Table>
      )}
    </>
  )
}
export default WorkroomTable
